import React, { useEffect, useRef, useState } from "react";
import "../css/Header1.css";

const NAV_ITEMS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/plans", label: "Membership" },
  { href: "/workouts", label: "Workouts" },
  { href: "/trainers", label: "Trainers" },
  { href: "/gallery", label: "Gallery" },
  { href: "/contact", label: "Contact" },
  { href: "/faqs", label: "FAQs" },
  { href: "/services", label: "Services" },
];

const Header1 = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activePath, setActivePath] = useState("/");
  const navRef = useRef(null);
  const rafRef = useRef(null);
  const pointerState = useRef({ x: 0, y: 0, target: null });

  useEffect(() => {
    if (typeof window !== "undefined") {
      setActivePath(window.location.pathname || "/");
    }

    const onScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  /* ----------- ADDED: RESPONSIVE NAV HANDLER ----------- */
  useEffect(() => {
    const resizeHandler = () => {
      if (window.innerWidth <= 1100) {
        if (navRef.current) navRef.current.style.display = "none";
      } else {
        if (navRef.current) navRef.current.style.display = "flex";
      }
    };

    resizeHandler();
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, []);
  /* ------------------------------------------------------ */

  useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;

    let hovered = null;

    const onMove = (e) => {
      pointerState.current.x = e.clientX;
      pointerState.current.y = e.clientY;
    };

    const onEnter = (ev) => {
      hovered = ev.currentTarget;
      pointerState.current.target = hovered;
    };

    const onLeave = () => {
      if (hovered) hovered.style.transform = `translate3d(0,0,0)`;
      hovered = null;
      pointerState.current.target = null;
    };

    const links = Array.from(nav.querySelectorAll(".header1-nav a"));
    links.forEach((a) => {
      a.addEventListener("pointerenter", onEnter);
      a.addEventListener("pointerleave", onLeave);
      a.addEventListener("pointermove", onMove);
    });

    const loop = () => {
      const t = pointerState.current;
      const el = t.target;
      if (el) {
        const r = el.getBoundingClientRect();
        const dx = (t.x - (r.left + r.width / 2)) / r.width;
        const dy = (t.y - (r.top + r.height / 2)) / r.height;
        const max = 8;
        el.style.transform = `translate3d(${(dx * max).toFixed(
          2
        )}px, ${(dy * max).toFixed(2)}px, 0)`;
      }
      rafRef.current = requestAnimationFrame(loop);
    };
    loop();

    return () => {
      links.forEach((a) => {
        a.removeEventListener("pointerenter", onEnter);
        a.removeEventListener("pointerleave", onLeave);
        a.removeEventListener("pointermove", onMove);
      });
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  useEffect(() => {
    const panel = document.querySelector(".side-links");
    if (!panel) return;

    const children = Array.from(panel.children);

    if (open) {
      children.forEach((ch, i) => {
        ch.style.transition = `transform 420ms cubic-bezier(.2,.9,.2,1) ${
          60 * i
        }ms, opacity 420ms ease ${60 * i}ms`;
        ch.style.transform = "translateX(0)";
        ch.style.opacity = "1";
      });
    } else {
      children.forEach((ch) => {
        ch.style.transition = "none";
        ch.style.transform = "translateX(18px)";
        ch.style.opacity = "0";
      });
    }
  }, [open]);

  return (
    <>
      <header className={`header1 ${scrolled ? "scrolled" : ""}`} aria-hidden={open}>
        <div className="header1-left">
          <div className="header1-logo">ACE</div>
        </div>

        <nav className="header1-nav" ref={navRef}>
          {NAV_ITEMS.map((it) => {
            const isActive =
              activePath === it.href ||
              (it.href !== "/" && activePath.startsWith(it.href));
            return (
              <a
                key={it.href}
                href={it.href}
                className={isActive ? "nav-link active" : "nav-link"}
              >
                {it.label}
                <span className="nav-underline" />
              </a>
            );
          })}
        </nav>

        <div
          className={`hamburger ${open ? "is-open" : ""}`}
          onClick={() => setOpen((s) => !s)}
        >
          <span />
          <span />
          <span />
        </div>
      </header>

      <aside className={`side-panel ${open ? "open" : ""}`}>
        <button className="side-close" onClick={() => setOpen(false)}>
          <span />
          <span />
        </button>

        <div className="side-inner">
          <div className="side-brand">
            <div className="logo-large">ACE</div>
            <div className="side-sub">Ace Fitness</div>
          </div>

          <nav className="side-links">
            {NAV_ITEMS.map((it) => (
              <a key={it.href} href={it.href} onClick={() => setOpen(false)}>
                {it.label}
              </a>
            ))}
          </nav>

          <div className="side-footer">
            <small>© {new Date().getFullYear()} ACE Gym</small>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Header1;
